import { render, staticRenderFns } from "./RecuperarSenha.vue?vue&type=template&id=4f44b8fc"
import script from "./RecuperarSenha.vue?vue&type=script&lang=js"
export * from "./RecuperarSenha.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./RecuperarSenha.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\src\\Presentation\\Vue\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f44b8fc')) {
      api.createRecord('4f44b8fc', component.options)
    } else {
      api.reload('4f44b8fc', component.options)
    }
    module.hot.accept("./RecuperarSenha.vue?vue&type=template&id=4f44b8fc", function () {
      api.rerender('4f44b8fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/autenticacao/RecuperarSenha.vue"
export default component.exports